import { useSession } from "@dashboard/hooks/use-session.hook";
import { useSignupCouponValidationEffect } from "@dashboard/hooks/use-signup-coupon.hook";
import { partnerSelector } from "@dashboard/config/redux";
import { useLocalStorage } from "@domun/component-library";
import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { Loader } from "@dashboard/assets/icons";
import { LoaderStatusWrapper } from "./loader-status.styled";
import { useTranslation } from "react-i18next";

const LoaderStatus: FC = () => {
  const { t } = useTranslation();
  const { checkUserInfo, decodedToken } = useSession();
  const partner = useSelector(partnerSelector);
  const [token] = useLocalStorage("accessToken", "");

  useSignupCouponValidationEffect({
    token,
    country: partner?.userDetail?.country,
  });

  useEffect(() => {
    if (decodedToken) {
      checkUserInfo();
    }
  }, [decodedToken]);

  return (
    <LoaderStatusWrapper>
      <div className="container">
        <Loader />
        <div className="spinnerText">{t("status.loaderText")}</div>
      </div>
    </LoaderStatusWrapper>
  );
};

export default LoaderStatus;
